import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";
const GIS_SRC = "https://accounts.google.com/gsi/client";

let gisPromise = null;
function loadGis() {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (gisPromise) return gisPromise;
  gisPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = GIS_SRC;
    s.async = true;
    s.defer = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return gisPromise;
}

// Cache the client-id lookup across modal opens
let configPromise = null;
function fetchClientId() {
  if (!configPromise) {
    configPromise = axios
      .get(`${API_URL}/auth/google/config`)
      .then((r) => (r.data?.enabled ? r.data.client_id : ""))
      .catch(() => "");
  }
  return configPromise;
}

export default function GoogleSignInButton({ onSuccess, onError }) {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function handleCredential(response) {
      try {
        const res = await axios.post(`${API_URL}/auth/google`, {
          credential: response.credential,
        });
        localStorage.setItem("oryyn_token", res.data.token);
        localStorage.setItem("oryyn_user", JSON.stringify(res.data.user));
        onSuccess?.(res.data.user);
      } catch (err) {
        onError?.(err.response?.data?.detail || "Google sign-in failed");
      }
    }

    (async () => {
      const clientId = await fetchClientId();
      if (cancelled || !clientId) return;
      await loadGis();
      if (cancelled || !window.google?.accounts?.id) return;
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredential,
      });
      if (ref.current) {
        window.google.accounts.id.renderButton(ref.current, {
          theme: "outline",
          size: "large",
          width: 320,
          text: "continue_with",
          shape: "rectangular",
          logo_alignment: "center",
        });
        setReady(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [onSuccess, onError]);

  // Renders nothing until Google is configured + the button is drawn
  return (
    <div style={{ display: ready ? "block" : "none", marginBottom: 16 }}>
      <div ref={ref} style={{ display: "flex", justifyContent: "center" }} />
      <div className="auth-divider"><span>or</span></div>
    </div>
  );
}
